import { createSlice } from '@reduxjs/toolkit'
const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState: {
    hidePlaylistPublishWarning:
      window.localStorage.getItem('hidePlaylistPublishWarning') || 0,
  },
  reducers: {
    setUserPreference(state, action) {
      const { key, value } = action.payload
      state[key] = value
    },
  },
})

export const selectUserPreference = (state, key) => state.userPreferences[key]

const { actions, reducer } = userPreferencesSlice
export const { setUserPreference } = actions

export default reducer
